import { useMap } from 'react-map-gl';
import Home from '@mui/icons-material/Home';
import PropTypes from 'prop-types';

//TODO: Move to config file
const arkansasBounds = [[-94.617919, 33.004106], [-89.644395, 36.4996]];

const MapHomeButton = (props) => {
	const map = useMap();

	const goHome = () => {
		const maplibre = map.current.getMap();
		if (!map) return;
		maplibre.fitBounds(arkansasBounds, { duration: 1000, padding: {left: 10, right: 10} });
	}

	return (
		<button onClick={goHome} className="custom-widget-button" style={{position: 'absolute', top: '174px', right: '10px', zIndex: 4}}>
			<Home />

		</button>
	)
}

export default MapHomeButton;